import { Route, Routes, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';

import './App.css';
import { ParticipantLayout, OperatorLayout } from './components/layouts';
import {
  AccumulatedValuePage,
  DashboardPage,
  FeaturePage,
  FeaturesPage,
  JoinSimulationPage,
  NotFoundPage,
  OperatorPage,
  OperatorQRPage,
  OperatorSimulationsPage,
  TaskPage,
  TasksPage,
  UnauthorizedPage,
} from './components/pages';

export function App() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        {/* Public routes */}
        <Route path="/" element={<JoinSimulationPage />} />
        <Route path="/join/:simulationLabel" element={<JoinSimulationPage />} />

        {/* Participant — layout resolves :simId + :teamName */}
        <Route path="/sim/:simId/:teamName" element={<ParticipantLayout />}>
          <Route path="tasks" element={<TasksPage />} />
          <Route path="tasks/:taskId" element={<TaskPage />} />
          <Route path="features" element={<FeaturesPage />} />
          <Route path="features/:featureId" element={<FeaturePage />} />
        </Route>

        {/* Operator — simulation picker */}
        <Route path="/operator" element={<OperatorSimulationsPage />} />

        {/* Operator — layout resolves :simId */}
        <Route path="/operator/:simId" element={<OperatorLayout />}>
          <Route index element={<OperatorPage />} />
          <Route path="dashboard" element={<DashboardPage />} />
          <Route path="value" element={<AccumulatedValuePage />} />
          <Route path="qr" element={<OperatorQRPage />} />
        </Route>

        <Route path="/unauthorized" element={<UnauthorizedPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </AnimatePresence>
  );
}
